import { Injectable } from "@angular/core";
import { createLocalStorageAdapter, StateStorageOptions, BaseState } from "../state";
import { PropData, DEFAULT_PROP_DATA } from "./prop.model";

@Injectable({
  providedIn: 'root'
})
export class PropState extends BaseState<PropData> {
  protected override config: StateStorageOptions<PropData> = {
    defaultState: DEFAULT_PROP_DATA,
    adapters: [createLocalStorageAdapter<PropData>('core.prop.v1')]
  }
}
